// frontend/src/components/layout/HelpMenu.jsx
//
// Top-right "?" dropdown — the single entry point for help.
//
// Items:
//   - Help center  → external docs (new tab)
//   - Contact      → in-app modal (apiJson POST, fully i18n, see
//                    ContactSupportModal)
//   - Shortcuts    → opens the existing KeyboardShortcutsHelp modal
//
// Reuses the .dropdown / .dropdown-panel / .dropdown-button / .dropdown-divider
// classes shipped by styles/dropdown.css so the visual language matches
// the user and notification dropdowns next to it.

import { useTranslation } from 'react-i18next';
import { ICON, BookOpen, EnvelopeSimple, Keyboard } from '../../icons';
import './UserDropdown.css'; // pulls in shared styles/dropdown.css

import { HELP_CENTER_URL } from '../../config/helpCenter';
import { trackEvent } from '../../hooks/useTracking';

const ITEM_STYLE = {
  display: 'flex',
  alignItems: 'center',
  gap: 'var(--spacing-sm)',
};

function HelpMenu({ isOpen, onClose, onOpenContact, onOpenShortcuts }) {
  const { t } = useTranslation();

  if (!isOpen) return null;

  // A link out of the app, so no request of ours sees it: recorded here.
  const handleHelpCenter = () => {
    trackEvent('help_center_opened');
    onClose();
  };

  const handleContact = () => {
    onClose();
    onOpenContact();
  };

  const handleShortcuts = () => {
    onClose();
    onOpenShortcuts();
  };

  return (
    <div className="dropdown">
      <div className="dropdown-panel">
        <div className="dropdown-menu">
          <a
            href={HELP_CENTER_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="dropdown-button"
            style={ITEM_STYLE}
            onClick={handleHelpCenter}
          >
            <BookOpen size={ICON.md} />
            {t('help.helpCenter')}
          </a>

          <button
            className="dropdown-button"
            style={ITEM_STYLE}
            onClick={handleContact}
          >
            <EnvelopeSimple size={ICON.md} />
            {t('contact.title')}
          </button>

          <div className="dropdown-divider"></div>

          <button
            className="dropdown-button"
            style={ITEM_STYLE}
            onClick={handleShortcuts}
          >
            <Keyboard size={ICON.md} />
            {t('help.keyboardShortcuts')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default HelpMenu;
